import React, {Component} from 'react';
import {Row, Col, Button, Tooltip, Icon} from 'antd';

import FilterStateBadgeTag from './FilterStateBadgeTag'
import FilterGroupTreeSelect from './FilterGroupTreeSelect'
import FilterStationAutoComplete from './FilterStationAutoComplete'

class PresentationToolbar extends Component {

  handleTreeSelect = (ids) => {
    this.props.onTreeSelect(ids)
  }

  handleAutoCompleteSelect = (id) => {
    this.props.onAutoCompleteSelect(id)
  }

  handleConnectionCheck = (connected) => {
    this.props.onFilterConnection(connected)
  }

  handleAlarmCheck = (alarms) => {
    this.props.onFilterAlarms(alarms)
  }

  handleViewChange = (event) => {
    this.props.onViewChange()
  }

  render() {
    const {
      groups,
      treeGroups,
      filterGroups,
      stations,
      disconnect,
      dangerous,
      warning,
      normal,
      viewGridType,
      isMobile
    } = this.props

    return (<Row type="flex" align="middle" className="toolbar">
      <Col xs={{
          span: 10
        }} sm={{
          span: 5
        }} md={{
          span: 4
        }} lg={{
          span: 8
        }} xl={{
          span: 8
        }}>
        <FilterStateBadgeTag isMobile={isMobile} disconnect={disconnect} dangerous={dangerous} warning={warning} normal={normal} onConnectionCheck={this.handleConnectionCheck} onAlarmCheck={this.handleAlarmCheck}/>
      </Col>
      <Col xs={{
          span: 0
        }} sm={{
          span: 9
        }} md={{
          span: 9
        }} lg={{
          span: 7
        }} xl={{
          span: 6
        }}>
        <FilterGroupTreeSelect groups={groups} treeGroups={treeGroups} filterGroups={filterGroups} onSelect={this.handleTreeSelect}/>
      </Col>
      <Col xs={{
          span: 12,
          offset: 0
        }} sm={{
          span: 8
        }} md={{
          span: 9
        }} lg={{
          span: 7
        }} xl={{
          span: 6,
          offset: 1
        }}>
        <FilterStationAutoComplete stations={stations} onSelect={this.handleAutoCompleteSelect}/>
      </Col>
      <Col xs={{
          span: 2,
          offset: 0
        }} sm={{
          span: 1,
          offset: 1
        }} md={{
          span: 1
        }} lg={{
          span: 1,
          offset: 1
        }} xl={{
          span: 1,
          offset: 2
        }}>
        {
          !viewGridType
            ? <Tooltip placement="left" title="Camera">
                <Button type="primary" ghost="ghost" icon="camera-o" onClick={this.handleViewChange}></Button>
              </Tooltip>
            : <Tooltip placement="left" title="Trạm">
                <Button type="primary" ghost="ghost" icon="bars" onClick={this.handleViewChange}></Button>
              </Tooltip>
        }
      </Col>
    </Row>)
  }

}

export default PresentationToolbar;
/*
<Tooltip onClick={this.handleViewChange} title={viewGridType
    ? "DS trạm"
    : "DS camera"}><Icon type={viewGridType
? "bars"
: "camera-o"} style={{
fontSize: 24,
cursor: 'pointer',
float: 'right'
}}/></Tooltip>
*/



// WEBPACK FOOTER //
// ./src/components/PresentationToolbar.js